import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { performRentalPortalApplicantTransition } from '../../../../../../api'
import { useNotification, useUserData } from '../../../../../../hooks'
import { isApiConflictStatus } from '../../../../../../utils/api'
import { ConfirmationModal } from '../../../../../Confirmation'
import {
  APPLICANT_TRANSITION_ACTION,
  getIsMockApplicantId,
  postMockApplicantMoveToScreening,
} from '../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { QA_NAME_APPLICANT_MOVE_TO_SCREENING_CONFIRMATION } from '../../RentalPortalApplicantProfileHeaderStageSelect.constants'
import {
  getApplicantMoveToScreeningDescription,
  getApplicantMoveToScreeningNotifications,
} from '../../RentalPortalApplicantProfileHeaderStageSelect.utils'

export function useApplicantMoveToScreening() {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const { handleAddSuccessNotification } = useNotification()

  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  const [isMovingToScreening, setMovingToScreening] = useState(false)

  async function postApplicantMoveToScreening() {
    return getIsMockApplicantId(applicantId)
      ? postMockApplicantMoveToScreening({ applicantId, currentUser })
      : performRentalPortalApplicantTransition({
          action: APPLICANT_TRANSITION_ACTION.moveToScreening,
          id: applicantId,
        })
  }

  function handleSubmitMoveToScreening() {
    setMovingToScreening(true)

    return postApplicantMoveToScreening()
      .then(() => {
        handleCloseModal()

        handleAddSuccessNotification(
          'RentalPortal.ApplicantProfileMovedToScreeningNotificationKey'
        )

        return handleEntityReload()
      })
      .catch(error => {
        handleOpenMoveToScreeningConfirmation(error)

        return isApiConflictStatus(error?.response?.status)
          ? handleEntityReload()
          : null
      })
      .finally(() => {
        setMovingToScreening(false)
      })
  }

  function handleOpenMoveToScreeningConfirmation(error) {
    const notifications = error
      ? getApplicantMoveToScreeningNotifications({ error, t })
      : null

    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t(
            'RentalPortal.ApplicantProfileStageMoveToScreeningBtnKey'
          ),
        }}
        description={getApplicantMoveToScreeningDescription({
          applicantData,
          t,
        })}
        notifications={notifications}
        notificationsProps={{ notifications }}
        qaName={QA_NAME_APPLICANT_MOVE_TO_SCREENING_CONFIRMATION}
        title={t(
          'RentalPortal.ApplicantProfileMoveToScreeningConfirmationTitleKey'
        )}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitMoveToScreening}
      />
    )
  }

  function handleClickMoveToScreening() {
    handleOpenMoveToScreeningConfirmation(null)
  }

  return { handleClickMoveToScreening, isMovingToScreening }
}
